import { TileStatus, VxlCardGroupTile } from '@varo/graphql-schema-types';
import cardAdapterMap from 'features/home/HomeScreen/adapters/adapterMap/cardAdapterMap';
import mapHomeTiles from 'features/home/HomeScreen/adapters/mapHomeTiles/mapHomeTiles';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { CardGroupProps } from 'shared/containers/vxl/groups/CardGroup/CardGroup';
import {
  isChildNodeType,
  VXLChildNode,
  VXLSection,
  VXLSectionId,
} from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

interface VXLCardGroupNode extends VXLSection {
  name: VXLSectionId.CARD_GROUP;
  props: CardGroupProps;
}

const vxlCardGroupTile = (
  tile: VxlCardGroupTile,
  dependencies: HomeCardDependencies,
): Maybe<VXLCardGroupNode> => {
  if (tile.status !== TileStatus.Loaded) {
    return null;
  }

  /**
   * only 'child nodes' are supported here to prevent 'section recursion'
   * where sections are nested within sections. if you're trying to enable
   * this case you should be able to use a generic group instead.
   */
  const subTiles: VXLChildNode[] = mapHomeTiles(
    cardAdapterMap,
    tile.tiles,
    dependencies,
  ).filter(isChildNodeType);

  return {
    id: tile.id,
    name: VXLSectionId.CARD_GROUP,
    props: {
      titleText: tile.title,
      components: subTiles,
    },
  };
};

export default vxlCardGroupTile;
